import { ofType } from "redux-observable";
import { from } from "rxjs";
import { delay, filter, switchMap } from "rxjs/operators";
import { utilBuildings } from "../../../../utils/utilBuildings";
import { actionAddPelletsAnimations } from "../../../animation/actionPelletAnimations";
import { IdIcon } from "../../../generic/icon/IdIcon";
import { TypeActionBuildings } from "../actionBuildings";
import { TypeBuildingAction } from "../reducerBuildings";
export var epicBuildingAddToBase = function (action$) {
    return action$.pipe(ofType(TypeActionBuildings.FinishPlacement), filter(function (action) {
        var actionMatches = action.action === TypeBuildingAction.Construct;
        var workers = action.building && action.building.balancing.stage[0]
            ? action.building.balancing.stage[0].workers
            : 0;
        return actionMatches && workers < 0;
    }), 
    // add a small delay to allow building/callout to be re-rendered before starting pellet animation
    delay(25), switchMap(function (action) {
        var building = action.building;
        var origin = utilBuildings.getCenterPositionMinSquareGlobal(building);
        var rewardPellets = [
            {
                amount: building.balancing.stage[0].workers,
                icon: IdIcon.WorkersIcn,
            },
        ];
        return from([actionAddPelletsAnimations(building.balancing.id, rewardPellets, origin)]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/epics/epicBuildingAddToBase.ts
// module id = 2043
// module chunks = 3